import { createContext } from "react";

const defaultValue ={
    locale:'en',
    setLocal:()=>{}
}

export default createContext(defaultValue);